@if(component) {
<div>
    <h4 *iCms="'title' of component"
        text
        class="h2 center text"></h4>
    <div class="flex flex-justify-center p-t-10">
        <div class="w-10 w-12-m w-12-s p-l-10 p-r-10">
            <div [grid]="[1,2,3,3][client.sizeId]"
                 [gridRowGap]="4"
                 [gridColumnGap]="4">
                @for (job of visibleJobs; track job) {
                <div [gridColumn]="1"
                     class="p-t-10">
                    <h4 *iCms="'title' of job"
                        text
                        class="h3 col-12"></h4>
                    <p class="p-t-2">
                        <span class="s1">{{'Location:'|translate}}</span>&nbsp;
                        <span class="p1"
                              *iCms="'location' of job"
                              text></span>
                    </p>
                    <p class="m-b">
                        <span class="s1">{{'Closing date:'|translate}}</span>&nbsp;
                        <span class="p">{{(job.closing_date | date: 'd' | ordinal) + (job.closing_date | date : '
                            MMMM')}}</span>
                    </p>
                    <href [link]="job.cta_link">
                        <button type="button"
                                class="button-1">
                            <span *iCms="'cta_copy' of job"
                                  text
                                  class="button__body"></span>
                        </button>
                    </href>
                </div>
                }
            </div>
        </div>
    </div>
</div>
}
